import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

// Global console override for production
if (environment.production) {
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
  // console.warn and console.error remain active
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
